import { scaleSqrt, max } from "d3";
import LeafletMap from "./LeafletMap";
import React, { useMemo } from "react";
import ResetZoomButton from "./Components/ResetZoomButton";
import Legend from "./Components/Legend";
import KeyFiguresSection from "./Components/KeyFiguresSection";

// import PredictionFigure from "./Components/PredictionFigure";

const MapSection = (props) => {
  //set projection
  //const projection = geoMercator();
  //const path = geoPath(projection);

  //sizings
  const tooltipWidth = 250;

  const sizeScale = useMemo(() => {
    return scaleSqrt()
      .domain([
        1,
        max([
          max(props.newData, (d) => d.pv_count),
          max(props.newData, (d) => d.demo_count),
        ]),
      ])
      .range([3, 14]);
  }, [props.newData]);
  
  const showLegendHandler = () => {
    document.querySelector("#legend-content").style.transform =
      "translate(0,0)";
    document.querySelector("#legend-arrow").style.transform = "rotate(-180deg)";
  };

  const hideLegendHandler = () => {
    document.querySelector("#legend-content").style.transform =
      "translate(0,-100%)";
    document.querySelector("#legend-arrow").style.transform = "rotate(0)";
  };

  const showTooltipHandler = (country, event, iconExplanation) => {
    document.querySelector("#hover-tooltip").style.display = "block";
    document.querySelector(
      "#hover-tooltip"
    ).firstChild.textContent = `${country}${
      iconExplanation ? " | " + iconExplanation : ""
    }`;
  };
  const moveTooltipHandler = (event) => {
    let xPoint = event.containerPoint ?  event.containerPoint.x : event.clientX
    let yPoint = event.containerPoint ?  event.containerPoint.y : event.clientY
    let position = event.containerPoint ?  "absolute" : "fixed"
    document.querySelector("#hover-tooltip").style.left = `${
      xPoint + 10
    }px`;
    document.querySelector("#hover-tooltip").style.top = `${
      yPoint - 35
    }px`;
    document.querySelector("#hover-tooltip").style.position = position
  };
  const hideTooltipHandler = () => {
    document.querySelector("#hover-tooltip").style.display = "none";
  };

  const markerClickHandler = (country, index) => {
    props.setPositionHandler(country, true, index);
  };

  const overrideIconHeight = 45;
  const iconGap = 8;
  return (
    <div
      style={{
        position: "relative",
        width: props.width,
        height: props.height,
      }}
    >
      <LeafletMap
        region={props.region}
        zoomedCountry={props.zoomedCountry && props.zoomedCountry}
        setPositionHandler={props.setPositionHandler}
        resetPosition={props.resetPosition}
        trendCountries={props.trendCountries}
        mapBoxCoords={props.mapBoxCoords}
        setMap={props.setMap}
        map={props.map}
        center={props.startingPosition.center}
        zoom={props.startingPosition.zoom}
        width={props.width}
        height={props.height}
        newData={props.newData}
        sizeScale={sizeScale}
        iconsRef={props.iconsRef}
        geoJsonRef={props.geoJsonRef}
        showTooltipHandler={showTooltipHandler}
        hideTooltipHandler={hideTooltipHandler}
        moveTooltipHandler={moveTooltipHandler}
        newCountryList={props.newCountryList}
        markerClickHandler={markerClickHandler}
      />
      <KeyFiguresSection
        height={props.height}
        trendCountries={props.trendCountries}
        tooltipStatus={props.zoomedCountry}
        width={props.width}
        tooltipWidth={tooltipWidth}
        period={props.period}
        countryShown={props.zoomedCountry}
        showTooltipHandler={props.showTooltipHandler}
        hideTooltipHandler={props.hideTooltipHandler}
        moveTooltipHandler={props.moveTooltipHandler}
      />
      <Legend
        showLegendHandler={showLegendHandler}
        hideLegendHandler={hideLegendHandler}
        sizeScale={sizeScale}
        width={props.width}
      />
      <div
        id="hover-tooltip"
        className="hover-tooltip"
        style={{ borderRadius: 10 }}
      >
        <p>{props.hoverTooltipStatus && props.hoverTooltipStatus.content}</p>
      </div>
      <ResetZoomButton
        resetPosition={props.resetPosition}
        resetButtonDisplay={props.zoomedCountry}
      />
      <div
        style={{
          top: props.height,
          transform: `translate(${Math.floor(iconGap)}px,-${
            props.trendCountries["United States"] && props.trendCountries["United States"].length *
            (overrideIconHeight + iconGap)
          }px)`,
        }}
        className="override-icons"
      >
        {props.trendCountries["United States"] && props.trendCountries["United States"].map((country, index) => {
         return (
            <div
            key={index}
              style={{
                top: index * (overrideIconHeight + iconGap),
                height: overrideIconHeight,
                width: overrideIconHeight,
                display: props.zoomedCountry ? "none" : "flex",
              }}
              className="override-icon-single"
              onClick={() => markerClickHandler("United States", index)}
              onMouseOver={(event) => {
                showTooltipHandler(
                  country.countryTitle,
                  event,
                  country.content
                );
              }}
              onMouseMove={(event) => moveTooltipHandler(event)}
              onMouseOut={hideTooltipHandler}
            >
              <img
                style={{ width: "65%", height: "65%" }}
                src={`https://acleddata.com/wp-content/icons/svg/${(country.icon)}`}
              ></img>
            </div>
          )
        })}
      </div>
    </div>
  );
};

export default MapSection;
